import MultiSelect from "components/MultiSelect/MultiSelect";
import FormFieldProps from "components/form/FormFieldProps";
import * as React from "react";
import HostingTaskLimitChip from "shared/HostingTaskLimitChip";
import {HostedInstanceHostingTaskLimitValues} from "./hostingTaskLimitValues";
import {HostingTaskLimitResource} from "../client/resources/HostingTaskLimitResource";

interface HostingTaskLimitMultiSelectProps extends FormFieldProps<string[]> {
    autoFocus?: boolean;
    label?: string | JSX.Element;
    error?: string;
}

const HostingTaskLimitTypedMultiSelect = MultiSelect<HostingTaskLimitResource>();

const HostingTaskLimitMultiSelect: React.FC<HostingTaskLimitMultiSelectProps> = props => {
    const chipRenderer = (k: HostingTaskLimitResource, onRequestDelete: (event: object) => void) => {
        return <HostingTaskLimitChip hostingTaskLimit={k} onRequestDelete={onRequestDelete} />;
    };

    return <HostingTaskLimitTypedMultiSelect
        items={HostedInstanceHostingTaskLimitValues.map(t => ({
            Id: `${t}`, Name: `${t}`
        }))}
        fieldName="Hosting Task Limit"
        renderChip={chipRenderer}
        {...props} />;
};

export default HostingTaskLimitMultiSelect;
